"use strict";
import { useMemo } from "react";
import { nativeOnChain } from "constants/topazTokenList";
import { UniverseChainId } from "features/chains/types";
export default function useNativeCurrency(chainId) {
  return useMemo(
    () => chainId ? nativeOnChain(chainId) : (
      // display mainnet when not connected
      nativeOnChain(UniverseChainId.Mainnet)
    ),
    [chainId]
  );
}
